import type { IconName } from '../assets/icons';

export enum PROTECTED_ROUTE {
  ALERTS = '/alerts',
  ALERTS_SINGLE = '/alerts/$alertId',
  FACILITIES = '/facilities',
  FACILITY = '/facilities/$facilityId',
  FACILITY_EDIT = '/facilities/$facilityId/edit',
  MARKET_FACILITIES = '/market-facilities',
  MARKET_FACILITIES_FORM_NEW = '/market-facilities/form',
  MARKET_FACILITIES_FORM_EDIT = '/market-facilities/form/$formId',
  STAFF = '/staff',
  STAFF_SINGLE = '/staff/$staffId',
  RESIDENTS = '/residents',
  RESIDENT_SINGLE = '/residents/$residentId',
  MARKET_INTEL = '/market-intel',
  SETTINGS = '/settings',
  INVITE_ADMIN = '/settings/invite-admin',
  INVITE_REGULAR_USER = '/settings/invite-regular-user',
  USER = '/user',
  EXPORT_PDF = '/export-pdf',
  LOGIN_ACTIVITY = '/login-activity',
  STAFF_USAGE = '/staff-usage',
  CHANGELOG = '/changelog',
}

type SidebarPage = {
  href: PROTECTED_ROUTE;
  label: string;
  icon: IconName;
};

export const SIDEBAR_CONFIG: SidebarPage[] = [
  { href: PROTECTED_ROUTE.ALERTS, label: 'Alerts', icon: 'alert' },
  { href: PROTECTED_ROUTE.FACILITIES, label: 'Facilities', icon: 'home' },
  {
    href: PROTECTED_ROUTE.MARKET_FACILITIES,
    label: 'Market Facilities',
    icon: 'home',
  },
  { href: PROTECTED_ROUTE.STAFF, label: 'Staff', icon: 'two-avatars' },
  {
    href: PROTECTED_ROUTE.RESIDENTS,
    label: 'Residents',
    icon: 'profile-card',
  },
  { href: PROTECTED_ROUTE.MARKET_INTEL, label: 'Market Intel', icon: 'chart' },
  { href: PROTECTED_ROUTE.SETTINGS, label: 'Settings', icon: 'gear' },
];
